import { clientState } from '../services/clientState';
import { canOpenRoute } from '../services/routeAccess';
import { hasClientSession, logoutSession } from '../services/session';
// audit-safety-integrated
import { readJson, safeErrorMessage } from '../utils/auditSafety';
import React, { useState, useEffect } from 'react';
import { Bell } from "lucide-react";
import Notification from "./Notification";
import { useNavigate } from "react-router-dom";
import { List } from "lucide-react";
import { API_BASE_URL } from '../services/api';
const Header = () => {
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [userRole, setUserRole] = useState('');
  const [logoUrl, setLogoUrl] = useState('');
  const [showNotif, setShowNotif] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);
  const navigate = useNavigate();
  const [openMenu, setOpenMenu] = useState(false);
  const [openReportsMenu, setOpenReportsMenu] = useState(false);

  useEffect(() => {
    const getUserData = () => {
      try {
        const userData = clientState.getItem('user');
        const loginResponse = clientState.getItem('loginResponse');

        if (userData) {
          const parsedUser = JSON.parse(userData);
          return parsedUser;
        }

        if (loginResponse) {
          const parsedResponse = JSON.parse(loginResponse);
          return parsedResponse;
        }

        return null;
      } catch (error) {
        void 0;
        return null;
      }
    };

    const userData = getUserData();
    if (userData && userData.role) {
      setUserRole(userData.role);
    }
  }, []);

  const fetchNotificationCount = async () => {
    try {
      const sessionAvailable = hasClientSession();

      if (!sessionAvailable) {
        setNotificationCount(0);
        return;
      }

  const response = await fetch(
  `${API_BASE_URL}/notifications`,
  {
    headers: {

      "Content-Type": "application/json",
    },
  }
);

      const data = await readJson(response);
      if (!data.error && data.data) {
        const unreadCount = data.data.filter(notification => notification.unread !== false).length;
        setNotificationCount(unreadCount);
      } else {
        setNotificationCount(0);
      }
    } catch (err) {
      void 0;
      setNotificationCount(0);
    }
  };

  useEffect(() => {
    fetchNotificationCount();
    const interval = setInterval(fetchNotificationCount, 30000);
    return () => clearInterval(interval);
  }, []);

  const toggleProfile = () => {
    setIsProfileOpen(!isProfileOpen);
    setIsMobileMenuOpen(false);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    setIsProfileOpen(false);
  };

  const [loggingOut, setLoggingOut] = useState(false);
  const handleLogout = async () => {
    if (loggingOut) return;
    setLoggingOut(true);
    try {
      await logoutSession();
      window.location.replace('/login');
    } catch (error) {
      window.alert(safeErrorMessage(error));
    } finally { setLoggingOut(false); }
  };

  const [user, setUser] = useState(null);

  useEffect(() => {
    const getUserData = () => {
      try {
        const userData = clientState.getItem('user');
        const loginResponse = clientState.getItem('loginResponse');
        if (userData) {
          return JSON.parse(userData);
        }
        if (loginResponse) {
          return JSON.parse(loginResponse);
        }
        return null;
      } catch (error) {
        void 0;
        return null;
      }
    };

    const userData = getUserData();
    if (userData && userData.role) {
      setUserRole(userData.role);

      const fullResponse = clientState.getItem('loginResponse');
      const mergedUser = fullResponse
        ? { ...userData, ...JSON.parse(fullResponse) }
        : userData;

      setUser(mergedUser);

      if (mergedUser.role === 'rcs-admin' || mergedUser.role === 'rcs-store') {
        setLogoUrl('/images/logo.png');
      } else if (mergedUser?.department?.logo) {
        setLogoUrl(`https://rcs-dms.onlinetn.com/public/${mergedUser.department.logo}`);
      } else {
        setLogoUrl('/images/logo.png');
      }

      void 0;
      void 0;
      void 0;
      void 0;
      void 0;
    }
  }, []);

  const getNavigationButtons = () => {
    const buttons = [];

    if (userRole === 'rcs-admin') {
      buttons.push(
        <button
          key="dashboard"
          onClick={() => navigate('/dashboard')}
          className="flex items-center space-x-2 px-3 py-2 text-white hover:text-white hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
          </svg>
          <span className="font-medium text-sm">Dashboard</span>
        </button>
      );
      buttons.push(
        <button
          key="user"
          onClick={() => navigate('/user-creation')}
          className="flex items-center space-x-2 px-3 py-2 text-white hover:text-white hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
          </svg>
          <span className="font-medium text-sm">Department Profile</span>
        </button>
      );
      buttons.push(
        <button
          key="items"
          onClick={() => navigate('/item')}
          className="flex items-center space-x-2 px-3 py-2 text-white hover:text-white hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
          </svg>
          <span className="font-medium text-sm">Items</span>
        </button>
      );
      buttons.push(
        <button
          key="stores"
          onClick={() => navigate('/stores')}
          className="flex items-center space-x-2 px-3 py-2 text-white hover:text-white hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 4h16l-1 5H5L4 4zM3 9h18v11a1 1 0 01-1 1H4a1 1 0 01-1-1V9z" />
          </svg>
          <span className="font-medium text-sm">Stores</span>
        </button>
      );
buttons.push(
        <button
          key="indent-request"
          onClick={() => navigate('/indent-request')}
          className="flex items-center space-x-2 px-3 py-2 text-white hover:text-white hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
          </svg>
          <span className="font-medium text-sm">Indent</span>
        </button>
      );
buttons.push(
        <div key="reports-dropdown" className="relative">
          <button
            onClick={() => setOpenReportsMenu(prev => !prev)}
            className="flex items-center space-x-2 px-3 py-2 text-white hover:text-white hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            <span className="font-medium text-sm">Reports</span>
            <svg className={`w-3 h-3 ml-1 transform transition-transform ${openReportsMenu ? "rotate-180" : ""}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
            </svg>
          </button>

          {openReportsMenu && (
            <div className="absolute bg-white text-gray-700 mt-2 rounded-lg shadow-lg w-52 z-50">
              <button
                onClick={() => { navigate('/reports'); setOpenReportsMenu(false); }}
                className="block w-full text-left px-4 py-2 hover:bg-sky-50 hover:text-sky-700 rounded-t-lg"
              >
                Reports
              </button>
              <button
                onClick={() => { navigate('/reports/prison-report'); setOpenReportsMenu(false); }}
                className="block w-full text-left px-4 py-2 hover:bg-sky-50 hover:text-sky-700 rounded-b-lg"
              >
                Order Comparison Report
              </button>
            </div>
          )}
        </div>
      );
      buttons.push(
        <button
          key="jpc-user"
          onClick={() => navigate('/jpc-user')}
          className="flex items-center space-x-2 px-3 py-2 text-white hover:text-white hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
          <span className="font-medium text-sm">JPC User</span>
        </button>
      );
      buttons.push(
        <button
          key="Bill"
          onClick={() => navigate('/Billing')}
          className="flex items-center space-x-2 px-3 py-2 text-white hover:text-white hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1V2H4z"></path>
            <path d="M14 8H8"></path>
            <path d="M16 12H8"></path>
            <path d="M13 16H8"></path>
          </svg>
          <span className="font-medium text-sm">Bills</span>
        </button>
      );
    } else if (userRole === 'department') {
      buttons.push(
        <button
          key="dashboard"
          onClick={() => navigate('/dashboard')}
          className="flex items-center space-x-2 px-3 py-2 text-white hover:text-white hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
          </svg>
          <span className="font-medium text-sm">Dashboard</span>
        </button>
      );
      buttons.push(
        <button
          key="user"
          onClick={() => navigate('/user-creation')}
          className="flex items-center space-x-2 px-3 py-2 text-white hover:text-white hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
          </svg>
          <span className="font-medium text-sm">Users</span>
        </button>
      );
      buttons.push(
        <button
          key="diet"
          onClick={() => navigate('/diet')}
          className="flex items-center space-x-2 px-3 py-2 text-white hover:text-white hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
          </svg>
          <span className="font-medium text-sm">Diet</span>
        </button>
      );
      buttons.push(
        <button
          key="raised-indents"
          onClick={() => navigate('/indents-raised')}
          className="flex items-center space-x-2 px-3 py-2 text-white hover:text-white hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <span className="font-medium text-sm">Raised</span>
        </button>
      );
      buttons.push(
        <button
          key="masters"
          onClick={() => navigate('/masters')}
          className="flex items-center space-x-2 px-3 py-2 text-white hover:text-white hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
          </svg>
          <span className="font-medium text-sm">Masters</span>
        </button>
      );
      buttons.push(
        <button
          key="indent-request"
          onClick={() => navigate('/indent-request')}
          className="flex items-center space-x-2 px-3 py-2 text-white hover:text-white hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
          </svg>
          <span className="font-medium text-sm">Indent</span>
        </button>
      );
      buttons.push(
        <button
          key="branch-stores"
          onClick={() => navigate('/branch-stores')}
          className="flex items-center space-x-2 px-3 py-2 text-white hover:text-white hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
          </svg>
          <span className="font-medium text-sm">Stores</span>
        </button>
      );
      buttons.push(
        <button
          key="Bill"
          onClick={() => navigate('/Billing')}
          className="flex items-center space-x-2 px-3 py-2 text-white hover:text-white hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1V2H4z"></path>
            <path d="M14 8H8"></path>
            <path d="M16 12H8"></path>
            <path d="M13 16H8"></path>
          </svg>
          <span className="font-medium text-sm">Bills</span>
        </button>
      );
    } else if (userRole === 'dep-rep') {
      buttons.push(
        <button
          key="dashboard"
          onClick={() => navigate('/dashboard')}
          className="flex items-center space-x-2 px-3 py-2 text-white hover:text-white hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
          </svg>
          <span className="font-medium text-sm">Dashboard</span>
        </button>
      );
      buttons.push(
        <button
          key="indent-request"
          onClick={() => navigate('/indent-request')}
          className="flex items-center space-x-2 px-3 py-2 text-white hover:text-white hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
          </svg>
          <span className="font-medium text-sm">Indent</span>
        </button>
      );
    } else if (userRole === 'all-fun') {
      buttons.push(
        <div key="all-fun-menus" className="flex flex-col gap-1">
          <div className="flex items-center gap-1">
            <button onClick={() => navigate('/dashboard')} className="flex items-center space-x-1 px-2 py-1 text-white hover:bg-white hover:bg-opacity-20 rounded transition-all duration-200">
              <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
              </svg>
              <span className="font-medium text-xs">Dashboard</span>
            </button>
            <button onClick={() => navigate('/indent')} className="flex items-center space-x-1 px-2 py-1 text-white hover:bg-white hover:bg-opacity-20 rounded transition-all duration-200">
              <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              <span className="font-medium text-xs">Raising</span>
            </button>
            <button onClick={() => navigate('/indent-approval')} className="flex items-center space-x-1 px-2 py-1 text-white hover:bg-white hover:bg-opacity-20 rounded transition-all duration-200">
              <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              <span className="font-medium text-xs">List</span>
            </button>
            <button onClick={() => navigate('/stocks')} className="flex items-center space-x-1 px-2 py-1 text-white hover:bg-white hover:bg-opacity-20 rounded transition-all duration-200">
              <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 20h18M9 10v10m6-14v14" />
              </svg>
              <span className="font-medium text-xs">Stocks</span>
            </button>
            <button onClick={() => navigate('/grn')} className="flex items-center space-x-1 px-2 py-1 text-white hover:bg-white hover:bg-opacity-20 rounded transition-all duration-200">
              <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              <span className="font-medium text-xs">GRN</span>
            </button>
            <button onClick={() => navigate('/attendance')} className="flex items-center space-x-1 px-2 py-1 text-white hover:bg-white hover:bg-opacity-20 rounded transition-all duration-200">
              <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              <span className="font-medium text-xs">Roll</span>
            </button>
            <button onClick={() => navigate('/diet-plan')} className="flex items-center space-x-1 px-2 py-1 text-white hover:bg-white hover:bg-opacity-20 rounded transition-all duration-200">
              <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              <span className="font-medium text-xs">Plans</span>
            </button>
          </div>
        </div>
      );
    } else if (userRole === 'indent' || userRole === 'ind-ris') {
      buttons.push(
        <button
          key="dashboard"
          onClick={() => navigate('/dashboard')}
          className="flex items-center space-x-2 px-3 py-2 text-white hover:text-white hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
          </svg>
          <span className="font-medium text-sm">Dashboard</span>
        </button>
      );
      buttons.push(
        <button
          key="indent-raising"
          onClick={() => navigate('/indent')}
          className="flex items-center space-x-2 px-3 py-2 text-white hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          <span className="font-medium text-sm">Indent Raising</span>
        </button>
      );

      buttons.push(
        <div key="stock-diet-dropdown" className="relative">
          <button
            onClick={() => setOpenMenu(prev => !prev)}
            className="flex items-center space-x-2 px-3 py-2 text-white hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 20h18M9 10v10m6-14v14" />
            </svg>
            <span className="font-medium text-sm">Stock & Diet Roll</span>
            <svg className={`w-3 h-3 ml-1 transform transition-transform ${openMenu ? "rotate-180" : ""}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
            </svg>
          </button>

          {openMenu && (
            <div className="absolute bg-white text-gray-700 mt-2 rounded-lg shadow-lg w-40 z-50">
              <button
                onClick={() => navigate('/stocks')}
                className="block w-full text-left px-4 py-2 hover:bg-sky-50 hover:text-sky-700 rounded-t-lg"
              >
                Stocks
              </button>
              <button
                onClick={() => navigate('/attendance')}
                className="block w-full text-left px-4 py-2 hover:bg-sky-50 hover:text-sky-700 rounded-b-lg"
              >
                Diet Roll
              </button>
            </div>
          )}
        </div>
      );

      buttons.push(
        <button
          key="diet-plan"
          onClick={() => navigate('/diet-plan')}
          className="flex items-center space-x-2 px-3 py-2 text-white hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          <span className="font-medium text-sm">Diet Plans</span>
        </button>
      );
    } else if (userRole === 'pay-cre') {
      buttons.push(
        <button
          key="indent-request"
          onClick={() => navigate('/indent-request')}
          className="flex items-center space-x-2 px-3 py-2 text-white hover:text-white hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
          </svg>
          <span className="font-medium text-sm">Indent</span>
        </button>
      );
      buttons.push(
        <button
          key="stock"
          onClick={() => navigate('/stocks')}
          className="flex items-center space-x-2 px-3 py-2 text-white hover:text-white hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 20h18M9 10v10m6-14v14" />
          </svg>
          <span className="font-medium text-sm">Stocks</span>
        </button>
      );
      buttons.push(
        <button
          key="Bill"
          onClick={() => navigate('/Billing')}
          className="flex items-center space-x-2 px-3 py-2 text-white hover:text-white hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1V2H4z"></path>
            <path d="M14 8H8"></path>
            <path d="M16 12H8"></path>
            <path d="M13 16H8"></path>
          </svg>
          <span className="font-medium text-sm">Bills</span>
        </button>
      );
    } else if (userRole === 'supply') {
      buttons.push(
        <button
          key="grn"
          onClick={() => navigate('/grn')}
          className="flex items-center space-x-2 px-3 py-2 text-white hover:text-white hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          <span className="font-medium text-sm">GRN</span>
        </button>
      );
      buttons.push(
        <button
          key="stock"
          onClick={() => navigate('/stocks')}
          className="flex items-center space-x-2 px-3 py-2 text-white hover:text-white hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 20h18M9 10v10m6-14v14" />
          </svg>
          <span className="font-medium text-sm">Stocks</span>
        </button>
      );
    } else if (userRole === 'payment') {
      buttons.push(
        <button
          key="indent-ledger"
          onClick={() => navigate('/indent-ledger')}
          className="flex items-center space-x-2 px-3 py-2 text-white hover:text-white hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <span className="font-medium text-sm">Indent Ledger</span>
        </button>
      );
      buttons.push(
        <button
          key="stock"
          onClick={() => navigate('/stocks')}
          className="flex items-center space-x-2 px-3 py-2 text-white hover:text-white hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 20h18M9 10v10m6-14v14" />
          </svg>
          <span className="font-medium text-sm">Stocks</span>
        </button>
      );
    } else if (userRole === 'rcs-store') {
      buttons.push(
        <button
          key="dashboard"
          onClick={() => navigate('/dashboard')}
          className="flex items-center space-x-2 px-3 py-2 text-white hover:text-white hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
          </svg>
          <span className="font-medium text-sm">Dashboard</span>
        </button>
      );
      buttons.push(
        <button
          key="indent-request"
          onClick={() => navigate('/indent-request')}
          className="flex items-center space-x-2 px-3 py-2 text-white hover:text-white hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
          </svg>
          <span className="font-medium text-sm">Indent</span>
        </button>
      );
      buttons.push(
        <button
          key="items"
          onClick={() => navigate('/item')}
          className="flex items-center space-x-2 px-3 py-2 text-white hover:text-white hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
          </svg>
          <span className="font-medium text-sm">Items</span>
        </button>
      );
      buttons.push(
        <button
          key="Bill"
          onClick={() => navigate('/Billing')}
          className="flex items-center space-x-2 px-3 py-2 text-white hover:text-white hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1V2H4z"></path>
            <path d="M14 8H8"></path>
            <path d="M16 12H8"></path>
            <path d="M13 16H8"></path>
          </svg>
          <span className="font-medium text-sm">Bills</span>
        </button>
      );
      // buttons.push(
      //   <button
      //     key="branch-stores"
      //     onClick={() => navigate('/branch-stores')}
      //     className="flex items-center space-x-2 px-3 py-2 text-white hover:text-white hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200"
      //   >
      //     <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      //       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
      //     </svg>
      //     <span className="font-medium text-sm">Stores</span>
      //   </button>
      // );
      buttons.push(
        <button
          key="help-us"
          onClick={() => navigate('/feed-back')}
          className="flex items-center space-x-2 px-3 py-2 text-white hover:text-white hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 10h8M8 14h6m8-2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <span className="font-medium text-sm">Help Us</span>
        </button>
      );
      buttons.push(
        <button
          key="quantity-demand"
          onClick={() => navigate('/quantity-demand')}
          className="flex items-center space-x-2 px-3 py-2 text-white hover:text-white hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414A1 1 0 0121 9.414V19a2 2 0 01-2 2z" />
          </svg>
          <span className="font-medium text-sm">Quantity Demand</span>
        </button>
      );
    } else if (userRole === 'ind-apr' || userRole === 'st-ind-apr') {
      buttons.push(
        <button
          key="dashboard"
          onClick={() => navigate('/dashboard')}
          className="flex items-center space-x-2 px-3 py-2 text-white hover:text-white hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
          </svg>
          <span className="font-medium text-sm">Dashboard</span>
        </button>
      );
      buttons.push(
        <button
          key="indent-list"
          onClick={() => navigate('/indent-approval')}
          className="flex items-center space-x-2 px-3 py-2 text-white hover:text-white hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          <span className="font-medium text-sm">Indent List</span>
        </button>
      );
      buttons.push(
        <button
          key="grn"
          onClick={() => navigate('/grn')}
          className="flex items-center space-x-2 px-3 py-2 text-white hover:text-white hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
          </svg>
          <span className="font-medium text-sm">GRN</span>
        </button>
      );
      buttons.push(
        <button
          key="stock"
          onClick={() => navigate('/stocks')}
          className="flex items-center space-x-2 px-3 py-2 text-white hover:text-white hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 20h18M9 10v10m6-14v14" />
          </svg>
          <span className="font-medium text-sm">Stocks</span>
        </button>
      );
      buttons.push(
        <button
          key="item-selection"
          onClick={() => navigate('/Item-Selection')}
          className="flex items-center space-x-2 px-3 py-2 text-white hover:text-white hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200"
        >
          <List className="w-4 h-4" />
          <span className="font-medium text-sm">Items Selection</span>
        </button>
      );
      if (userRole === 'st-ind-apr') {
        buttons.push(
          <button
            key="eater-count"
            onClick={() => navigate('/eater-count')}
            className="flex items-center space-x-2 px-3 py-2 text-white hover:text-white hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
            <span className="font-medium text-sm">Units</span>
          </button>
        );
      }
      buttons.push(
        <button
          key="help-us"
          onClick={() => navigate('/feed-back')}
          className="flex items-center space-x-2 px-3 py-2 text-white hover:text-white hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 10h8M8 14h6m8-2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <span className="font-medium text-sm">Help Us</span>
        </button>
      );
} else if (userRole === 'jpc-staff') {
      buttons.push(
        <button
          key="price-updation"
          onClick={() => navigate('/price-updation')}
          className="flex items-center space-x-2 px-3 py-2 text-white hover:text-white hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <span className="font-medium text-sm">Price Updation</span>
        </button>
      );
    } else {
      buttons.push(
        <button
          key="segment"
          onClick={() => navigate('/create')}
          className="flex items-center space-x-2 px-3 py-2 text-white hover:text-white hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
          </svg>
          <span className="font-medium text-sm">Diet Plan</span>
        </button>
      );
      buttons.push(
        <button
          key="indent"
          onClick={() => navigate('/indent')}
          className="flex items-center space-x-2 px-3 py-2 text-white hover:text-white hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          <span className="font-medium text-sm">Indent</span>
        </button>
      );
      buttons.push(
        <button
          key="user"
          onClick={() => navigate('/user-creation')}
          className="flex items-center space-x-2 px-3 py-2 text-white hover:text-white hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
          </svg>
          <span className="font-medium text-sm">Department Profile</span>
        </button>
      );
    }

    return buttons.filter(button => button.key !== 'grn' || canOpenRoute('/grn'));
  };

  return (
    <>
    <header className="bg-[#1978B5] border-b border-[#146699] shadow-lg">
      <div className="w-full mx-auto px-2 sm:px-4 lg:px-8">
        <div className="flex items-center justify-between py-2 sm:py-3 lg:py-4 gap-1 sm:gap-2">
          <div className="flex items-center space-x-2 sm:space-x-3 flex-1 min-w-0">
            {logoUrl && (
              <div className="flex-shrink-0">
                <img
                  src={logoUrl}
                  alt="Department Logo"
                  className="h-8 w-8 sm:h-10 sm:w-10 lg:h-12 lg:w-12 object-contain rounded-md"
                />
              </div>
            )}

            <div className="min-w-0 flex-1">
              {(userRole === 'rcs-admin' || userRole === 'rcs-store' || userRole === 'jpc-staff') ? (
                <>
                  <h1 className="text-[10px] sm:text-sm lg:text-base xl:text-lg font-bold text-white leading-tight">
                    தமிழ்நாட்டின் கூட்டுறவு சங்கங்கள்
                  </h1>
                  <p className="text-[10px] sm:text-sm lg:text-base xl:text-lg text-white font-medium leading-tight">
                    TamilNadu Cooperative Societies
                  </p>
                </>
              ) : (
                <>
                  <h1 className="text-xs sm:text-base lg:text-lg xl:text-xl font-bold text-white leading-tight">
                    {user?.department?.banner_name || 'N/A'}
                  </h1>
                  <h5 className="text-[8px] sm:text-xs lg:text-sm xl:text-base font-bold text-white leading-tight">
                    {user?.department?.banner_name_ta || 'N/A'}
                  </h5>
                </>
              )}
            </div>
          </div>

          <div className="flex items-center space-x-1 sm:space-x-2 flex-shrink-0">
            <div className="hidden md:flex items-center space-x-1 lg:space-x-2 flex-wrap max-w-[50vw] lg:max-w-none">
              {getNavigationButtons()}
            </div>

            <div className="md:hidden relative">
              <button
                onClick={toggleMobileMenu}
                className="flex items-center justify-center w-8 h-8 sm:w-9 sm:h-9 bg-white bg-opacity-90 hover:bg-opacity-100 text-sky-600 hover:text-sky-700 rounded-lg transition-all duration-200 shadow-md hover:shadow-lg"
                title="Menu"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              </button>

              {isMobileMenuOpen && (
                <>
                  <div
                    className="fixed inset-0 z-40 bg-black bg-opacity-25"
                    onClick={toggleMobileMenu}
                  ></div>

                  <div className="absolute right-0 mt-2 w-48 bg-white rounded-xl shadow-xl border border-gray-100 py-2 z-50">
                    <div className="px-2 space-y-1">
                      {getNavigationButtons().map((button) => (
                        <div key={button.key} className="block" onClick={toggleMobileMenu}>
                          {React.cloneElement(button, {
                            className: "flex items-center space-x-3 w-full px-4 py-3 text-gray-700 hover:bg-sky-50 hover:text-sky-700 transition-colors duration-200 rounded-lg"
                          })}
                        </div>
                      ))}
                    </div>

                    <div className="border-t border-gray-200 my-2"></div>

                    <button
                      onClick={handleLogout}
                      className="w-full flex items-center space-x-3 px-4 py-3 text-red-600 hover:bg-red-50 transition-colors duration-200"
                    >
                      <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                      </svg>
                      <span className="font-medium">Logout</span>
                    </button>
                  </div>
                </>
              )}
            </div>

            <div className="flex items-center space-x-1 sm:space-x-2">
              <div className="relative">
                <button
                  onClick={() => setShowNotif(true)}
                  className="flex items-center justify-center w-8 h-8 sm:w-9 sm:h-9 text-white hover:text-gray-200 transition-all duration-200 focus:outline-none relative"
                  title="Notifications"
                >
                  <Bell className="w-5 h-5" />
                  {notificationCount > 0 && (
                    <div className="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold rounded-full min-w-[20px] h-5 flex items-center justify-center px-1">
                      {notificationCount > 99 ? '99+' : notificationCount}
                    </div>
                  )}
                </button>
              </div>

              <div className="relative hidden md:block">
                <button
                  onClick={toggleProfile}
                  className="flex items-center justify-center w-9 h-9 sm:w-10 sm:h-10 text-white hover:text-gray-200 transition-all duration-200 focus:outline-none"
                  title="Profile"
                >
                  <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                </button>

                {isProfileOpen && (
                  <>
                    <div
                      className="fixed inset-0 z-40 bg-black bg-opacity-25"
                      onClick={toggleProfile}
                    ></div>

                    <div className="absolute right-0 mt-2 w-56 bg-white rounded-xl shadow-xl border border-gray-100 z-50">
                      <div className="px-4 py-3 text-sm text-gray-800 space-y-1">
                        <div className="font-semibold text-gray-900">
                          {JSON.parse(clientState.getItem('user'))?.name || 'N/A'}
                        </div>
                        <div className="text-gray-700">
                          {JSON.parse(clientState.getItem('user'))?.username || 'N/A'}
                        </div>
                      </div>

                      <div className="border-t border-gray-200"></div>

                      <button
                        onClick={() => navigate("/password-change")}
                        className="w-full flex items-center px-4 py-3 text-gray-700 hover:bg-gray-50 transition-colors duration-200 text-sm font-medium"
                      >
                        <svg
                          className="w-5 h-5 mr-2 flex-shrink-0"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M12 11c0-1.105.895-2 2-2s2 .895 2 2v2m-4 0h4m-6 0h.01M12 17h.01M17 16v1a3 3 0 01-3 3H7a3 3 0 01-3-3v-1a3 3 0 013-3h7a3 3 0 013 3z"
                          />
                        </svg>
                        Change Password
                      </button>

                      {userRole === 'rcs-store' && (
                        <button
                          onClick={() => navigate("/bank-details")}
                          className="w-full flex items-center px-4 py-3 text-gray-700 hover:bg-gray-50 transition-colors duration-200 text-sm font-medium"
                        >
                          <svg
                            className="w-5 h-5 mr-2 flex-shrink-0"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M3 10l9-7 9 7v10a2 2 0 01-2 2H5a2 2 0 01-2-2V10z"
                            />
                          </svg>
               Store details
                        </button>
                      )}

                      <button
                        onClick={handleLogout}
                        className="w-full flex items-center px-4 py-3 text-red-600 hover:bg-red-50 transition-colors duration-200 text-sm font-medium"
                      >
                        <svg
                          className="w-5 h-5 mr-2 flex-shrink-0"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                          />
                        </svg>
                        Logout
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>

            <Notification
              show={showNotif}
              onClose={() => setShowNotif(false)}
            />

            <div className="flex items-center space-x-1 sm:space-x-2">
              <div className="text-right hidden xs:block">
                <h1 className="text-[9px] sm:text-xs lg:text-sm font-semibold text-white leading-tight">
                  Kooturavu
                </h1>
                <h2 className="text-[9px] sm:text-xs lg:text-sm font-bold text-white leading-tight text-left">
                  Santhai
                </h2>
              </div>

              <div className="flex-shrink-0">
                <img
                  src="/images/logo192.png"
                  alt="Government Logo"
                  className="h-10 w-10 sm:h-12 sm:w-12 lg:h-14 lg:w-14 object-contain rounded-md"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>

</>
  );
};

export default Header;
